import ReactDOM from 'react-dom';

import App from './components/app/app';

ReactDOM.render(<App />, document.getElementById('root'));
